import { Brick, registerBrick } from 'olympe'

export default class GetLocalStorage extends Brick {
  /**
   * Executed every time the brick receives a new trigger event.
   * Note that the method will be executed _even if_ an input (key) is undefined.
   *
   * @protected
   * @param {BrickContext} context
   * @param {string} key
   * @param {function()} forwardEvent
   * @param {function(string)} setValue
   */
  onUpdate(context, [key], [forwardEvent, setValue]) {
    // Making sure the browser support local storage
    if (typeof Storage !== 'undefined') {
      setValue(localStorage.getItem(key))
      forwardEvent()
    } else {
      throw new Error(`Your browser does not support the window.localStorage API`)
    }
  }
}

registerBrick('017a1a0c85b076246e6e', GetLocalStorage)
